import dynamic         from "next/dynamic";
import { useRouter }   from "next/router";
import { isPageRoute } from "_common/utils";
import useStyles       from "_styles/templates/layout";
const Header             = dynamic ( () => import ( "_components/organisms/header" ) );
const BottomStickyButton = dynamic ( () => import ( "_components/atoms/bottomStickyButton" ) );

const component = props => {
	const {
		children
	} = props;

	const classes               = useStyles ();
	const router                = useRouter ();
	const isStreamPage          = isPageRoute ( { router, page: "stream" } );
	const isVideoPage           = isPageRoute ( { router, page: "video" } );
	const isActivatePage        = isPageRoute ( { router, page: "activate" } );
	const isGrowthDashboardPage = isPageRoute ( { router, page: "growth-dashboard" } );
	const isModFeedPage         = isPageRoute ( { router, page: "modfeed" } );
	const isTopCreatorsPage     = isPageRoute ( { router, page: "top-creators" } );
	const isNotificationsPage   = isPageRoute ( { router, page: "notifications" } );
	const resultsPage           = isPageRoute ( { router, page: "results" } );
	const suggestionPage        = isPageRoute ( { router, page: "search-suggestions" } );

	if ( isPageRoute ( { router, page: "download" } ) )
		return (
			<div
				style = {
					{ width: "100%", display: "flex", flexDirection: "column" }
				}
			>
				{ children }
			</div>
		);

	return (
		<div className = { classes.wrapper }>
			{isPageRoute ( { router, page: "modfeed" } ) || isActivatePage || isNotificationsPage || isTopCreatorsPage ?
				null : (
					<Header
						hidden = { resultsPage || suggestionPage }
					/>
				)}

			{ isPageRoute ( { router, page: "modfeed" } ) || isPageRoute ( { router, page: "mods" } ) || isActivatePage || isGrowthDashboardPage || isTopCreatorsPage || isNotificationsPage ? null : (
				<BottomStickyButton
					customStyles
					title = { isStreamPage ? "Open App to Chat" : "Open in App" }
				/>
			)}

			{

				 ( isVideoPage || isStreamPage || isModFeedPage || isNotificationsPage || isTopCreatorsPage || resultsPage ) ?
					children : (
						<div style = { { marginTop: "60px", marginBottom: "65px" } }>

							{children}

						</div>
					)
			}
		</div>
	);
};

export default component;
